import { PUBLIC_APP_ENV } from '$app/env/public';

export const isOnProductionOnly = () => {
	return PUBLIC_APP_ENV === 'production';
};
